import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation} from 'react-router-dom';
import SideNav from '../../common/SideNav';
import GoalEditor from '../../common/GoalEditor';
import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    TablePagination,
    Select,
    MenuItem,
    FormControl,
} from '@mui/material';
import * as C from '../../../services/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
    hasSideBar,
    toggleSideBar,
    updateCurrentComponent,
} from '../../../store/actions/navActions';
import {
    hideLoading,
    showLoading,
} from '../../../store/actions/loadingActions';
import {
    notifyError,
    notifySuccess,
} from '../../../store/actions/notificationActions';
import { nonEmptyString } from '../../../services/typeUtils';
import { getWeight, updateGoalStatus } from '../../../services/api/nbaApi';
import CustomMuiTable from './CustomMuiTable';


const tableHeader = {
    GoalID: 'Goal ID',
    GoalType: 'Goal Type', // Changed from Goal: 'Goal'
    GoalName: 'Goal Name', //--
    Weight: 'Weight',
    // Product: 'Product',
    // BrandFamily: 'Brand Family',
    Status: 'Status', //--
    CreatedAt: 'Created At',
    actions: 'Actions',
};
const filterColumns = [
    'GoalID',
    'GoalType',
    'GoalName',
    'Weight',
    //  "Product",
    // 'BrandFamily',
    'Status',
    'CreatedAt',
];
const goalTypeOptions = ['Cross sell', 'Up sell', 'Loyalty', 'Repeat Purchase'];
// const productOptions = ['ELECTRONICS', 'CLOTHING', 'BOOKS', 'SPORTS', 'HOME'];

const DashboardPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const fields = Object.keys(tableHeader);
    const dispatch = useDispatch();
    const { market, brand } = useSelector((state) => state.auth.user);
    const [page, setPage] = useState(0);
    const [editingRow, setEditingRow] = useState(null);
    const [filteredAndSortedData, setFilteredAndSortedData] = useState([]);
    const [goalId, setGoalId] = useState(null);
    const [showGoalEditor, setShowGoalEditor] = useState(false);
    const [type, setType] = useState(C.GOAL_TYPE_NEW);

    const handlePageChange = (event, page) => {
        setPage(page);
    };

    const openGoalEditor = (status, goalId = null) => {
        setGoalId(goalId);
        setType(status);
        setShowGoalEditor(true);
    };

    const closeGoalEditor = () => {
        setGoalId(null);
        setShowGoalEditor(false);
        // Refresh data after closing editor
        loadGoalData();
    };

    const loadGoalData = () => {
        dispatch(showLoading());
        getWeight(market, brand)
            // getWeight('US','IQOS')
            .then((response) => {
                console.log('Weight data:', response.data);
                const existingGoals = response.data
                    .map((weight) => ({
                        GoalID: weight?.goalId?.toString() || '',
                        GoalType: weight?.goalType || '',
                        GoalName: weight?.goalName || '',
                        Weight: weight?.weight
                            ? parseFloat(weight?.weight).toFixed(2)
                            : '0.00',
                        // BrandFamily: weight?.brandFamily || '', // Add fallback for null/undefined
                        Status: weight?.goalStatus?.toLowerCase() || 'inactive',
                        CreatedAt: weight?.createdAt
                            ? new Date(weight?.createdAt).toLocaleDateString()
                            : '-',
                    }))
                    // .sort((a, b) => {
                    //     // Sort active goals first, then inactive
                    //     if (a.Status === 'active' && b.Status === 'inactive')
                    //         return -1;
                    //     if (a.Status === 'inactive' && b.Status === 'active')
                    //         return 1;
                    //     return 0;
                    // });
                setFilteredAndSortedData(existingGoals);
            })
            .catch((error) => {
                dispatch(notifyError('Error!', 'Unable to fetch weight data.'));
            })
            .finally(() => dispatch(hideLoading()));
    };

    useEffect(() => {
    if (location.state?.openGoalEditor) {
        openGoalEditor(C.GOAL_TYPE_NEW);
        navigate('/nba2.0-dashboard', { replace: true });
    }
}, [location.state]);


    useEffect(() => {
        dispatch(updateCurrentComponent(C.APP_MANAGE_NBA2_PAGE_TITLE));
        dispatch(hasSideBar(true));
        dispatch(toggleSideBar(false));
        loadGoalData();
    }, [market, brand]);

    // Static data (commented out - now using API)
    // const [filteredAndSortedData, setFilteredAndSortedData] = useState([
    //     {
    //         ConfigurationID: 'Configuration ID',
    //         Goal: 'Goal',
    //         GoalName: 'Goal Name',
    //         Weight: 'Weight',
    //         Product: 'Product',
    //         Status: 'Status',
    //         Date: 'Date',
    //         actions: 'Actions',
    //     },
    //     // {
    //     //     ConfigurationID: 'Configuration ID',
    //     //     Goal: 'Goal',
    //     //     GoalName: 'Goal Name',
    //     //     Weight: 'Weight',
    //     //     Product: 'Product',
    //     //     Status: 'Status',
    //     //     Date: 'Date',
    //     //     actions: 'Actions',
    //     // },
    //     {
    //         ConfigurationID: 'Config-001',
    //         Goal: 'Engagement',
    //         GoalName: 'User Engagement',
    //         Weight: '75%',
    //         Product: 'NBA App',
    //         Status: 'active',
    //         Date: '2024-01-15',
    //     },
    //     {
    //         ConfigurationID: 'Config-002',
    //         Goal: 'Retention',
    //         GoalName: 'User Retention',
    //         Weight: '60%',
    //         Product: 'NBA Web',
    //         Status: 'active',
    //         Date: '2024-01-10',
    //     },
    // ]);

    const handleEdit = (rowData) => {
        if (rowData.Status === 'inactive') {
            return; // Prevent editing inactive goals
        }

        const goalType =
            rowData.Status === 'active'
                ? C.GOAL_TYPE_ACTIVE
                : C.GOAL_TYPE_INACTIVE;
        openGoalEditor(goalType, rowData.GoalID);
    };

   

    const handleActivateDeactivate = (rowData) => {
        const newStatus = rowData.Status === 'active' ? 'INACTIVE' : 'ACTIVE';

        dispatch(showLoading());
        updateGoalStatus(market, brand, rowData.GoalID, newStatus)
            .then(() => {
                setFilteredAndSortedData((prevData) =>
                    prevData
                        .map((item) =>
                            item.GoalID === rowData.GoalID
                                ? {
                                      ...item,
                                      Status: newStatus.toLowerCase(),
                                  }
                                : item
                        )
                        // .sort((a, b) => {
                        //     // Sort active goals first, then inactive
                        //     if (
                        //         a.Status === 'active' &&
                        //         b.Status === 'inactive'
                        //     )
                        //         return -1;
                        //     if (
                        //         a.Status === 'inactive' &&
                        //         b.Status === 'active'
                        //     )
                        //         return 1;
                        //     return 0;
                        // })
                );
                dispatch(
                    notifySuccess(
                        'Success!',
                        `Goal ${newStatus.toLowerCase()} successfully.`
                    )
                );
            })
            .catch((error) => {
                dispatch(
                    notifyError('Error!', 'Unable to update goal status.')
                );
            })
            .finally(() => dispatch(hideLoading()));
    };

    const renderFieldContent = (field, rowData) => {
       
        if (field === 'actions') {
            const isInactive = rowData.Status === 'inactive';

            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '8px',
                    }}
                >
                    <Button
                        className={`save-rule ${
                            isInactive ? 'inactive' : 'active'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                            opacity: isInactive ? 0.5 : 1,
                            cursor: isInactive ? 'not-allowed' : 'pointer',
                        }}
                        onClick={() => !isInactive && handleEdit(rowData)}
                        disabled={isInactive}
                    >
                        Edit
                    </Button>
                    <Button
                        className={`save-rule ${
                            isInactive ? 'inactive' : 'active'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                            opacity: isInactive ? 0.5 : 1,
                            cursor: isInactive ? 'not-allowed' : 'pointer',
                        }}
                        onClick={() =>
                            !isInactive && handleActivateDeactivate(rowData)
                        }
                        disabled={isInactive}
                    >
                        {rowData.Status === 'active'
                            ? 'Deactivate'
                            : 'Activate'}
                    </Button>
                </div>
            );
        }

        // console.log("rowData", rowData);
        // console.log("field", field);
        if (nonEmptyString(rowData[field])) {
            return rowData[field];
        }
        return '-';
    };
    const dataFormatter = (row, cols) => {
        return cols.map((field, idx) => (
            <TableCell
                key={idx}
                className="table-cell"
                style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    maxWidth: 250,
                }}
            >
                {renderFieldContent(field, row)}
            </TableCell>
        ));
    };
    return (
        <div className="component-container-root">
            <SideNav openGoalEditor={openGoalEditor} closeGoalEditor={closeGoalEditor}/>
            {showGoalEditor ? (
                <GoalEditor
                    status={showGoalEditor}
                    type={type}
                    goalId={goalId}
                    onClose={closeGoalEditor}
                    origin={C.GOAL_EDITOR_MANAGE_PROGRAM}
                />
            ) : (
                <Box className="manage-rules-container component-container">
                    <p className="instruction">
                        View and manage weight configurations for the NBA
                        program.
                    </p>
                    <h1>Market Configuration</h1>
                    <div
                        className="manage-rules"
                        style={{ textWrap: 'nowrap' }}
                    >
                        <CustomMuiTable
                            headerColumns={tableHeader}
                            rows={filteredAndSortedData}
                            dataFormatter={dataFormatter}
                            filterColumns={filterColumns}
                            sortingColumns={filterColumns}
                            defaultSortField={'GoalID'}
                            defaultSortOrder={'desc'}
                        />
                        <div className="table-footer">
                            <button
                                className="add-rule"
                                onClick={() => openGoalEditor(C.GOAL_TYPE_NEW)}
                            >
                                + Add
                            </button>
                        </div>
                    </div>
                </Box>
            )}
        </div>
    );
};

export default DashboardPage;
